module.exports = __webpack_public_path__ + "img/65734.7480463d.png";